import { HASHRATE } from 'src/api/HashrateFormatter';

export const hashrateUnitOptions = [
  {
    value: 'EH/s',
    label: HASHRATE.EHS.unitName
  },
  {
    value: 'PH/s',
    label: HASHRATE.PHS.unitName
  },
  {
    value: 'TH/s',
    label: HASHRATE.THS.unitName
  },
];

export const convertToGHValue = (selectedUnit, value) => {
  switch(selectedUnit){
    case "PH/s":
      return (value * HASHRATE.PHS.one) / HASHRATE.GHS.one
    case "TH/s":
      return (value * HASHRATE.THS.one) / HASHRATE.GHS.one
    case "EH/s":
      return (value * HASHRATE.EHS.one) / HASHRATE.GHS.one
    default:
      return (value * HASHRATE.GHS.one) / HASHRATE.GHS.one
  }
}



